import React, {useEffect, useState} from 'react';

export default function DoubleImageList(props) {

    const [pageHeight, setPageHeight] = useState(0)

    useEffect(() => {
        setPageHeight(props.boxHeight * props.boxHeightOffset / 100 / 2)
    }, [props.boxHeight, props.boxHeightOffset])

    return (<div className="fullWidth allCenter">
        <div className="fullWidth">
            <div className="clickable">
                <img className="fullWidth" style={{height: pageHeight}} src={props.list[0].image}
                     onClick={() => {
                         props.onClicked(props.list[0])
                     }}
                     alt={"صرفه مارکت"} />
            </div>
            <div className="clickable">
                <img className="fullWidth" style={{height: pageHeight}} src={props.list[1].image}
                     onClick={() => {
                         props.onClicked(props.list[1])
                     }}
                     alt={"صرفه مارکت"}/>
            </div>
        </div>
    </div>)
}